module.exports = __webpack_public_path__ + "img/certificate.4b470b7.svg";